<template>
   <div>
    <router-view/>
    <KakaoPopup/>
    <PopupBanner/>
   </div>
</template>

<script>
import index from './views/app/index'
import KakaoPopup from "@/container/KakaoPopup";
import PopupBanner from "@/container/PopupBanner";
export default {
  name: 'App',
  components: {
    KakaoPopup,
    PopupBanner,
    index
  },
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body, html {
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
  outline: none !important;
}

body, html, div, span, p, h1, h2, h3, h4, h5, h6, button, input, select, textarea {
  font-family: 'Pretendard', 'Nanum Gothic', sans-serif;
}

/* Font Awesome 아이콘은 원래 폰트 유지 */
.fa, .fas, .far, .fal, .fab {
  font-family: 'Font Awesome 5 Free', 'FontAwesome' !important;
}
</style>
